export enum CardType {
  CB_VISA_MASTERCARD = 'CB_VISA_MASTERCARD'
}
